import * as React from 'react';

import { get as getUser } from 'js/lib/user';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import { useConsumerMyPageHeader } from 'bundles/composable-page-header-consumer/contexts/ConsumerMyPageHeaderContext';
import { usePageHeaderHeight } from 'bundles/composable-page-header/contexts/PageHeaderHeightContext';
import EnterpriseReturnToProgramBanner from 'bundles/enterprise-legacy-learner-home/components/EnterpriseReturnToProgramBanner';

const BANNER_HEIGHT = 60;

const LegacyEnterpriseReturnToProgramBanner = () => {
  const { chosenEnterpriseProgram } = useConsumerMyPageHeader();
  const pageHeaderHeightContext = usePageHeaderHeight();

  const userId = getUser()?.id;

  // In legacy implementations, the EnterpriseReturnToProgramBanner would add a class to the parent element to adjust the height of the page header.
  // In the composable header, we will dynamically set the height of the page header via the PageHeaderHeightContext when either "addParentHeightClass" or "removeParentHeightClass" is called.
  const addHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }

    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height + BANNER_HEIGHT);
  };

  const removeHeight = (legacyArg: string) => {
    if (!pageHeaderHeightContext) {
      return;
    }

    pageHeaderHeightContext.setHeight(pageHeaderHeightContext.height - BANNER_HEIGHT);
  };

  if (!chosenEnterpriseProgram || !userId) {
    return null;
  }

  return (
    <PageGridContainer>
      <Grid item xs={12}>
        <EnterpriseReturnToProgramBanner
          addParentHeightClass={addHeight}
          removeParentHeightClass={removeHeight}
          userId={userId}
          program={chosenEnterpriseProgram}
        />
      </Grid>
    </PageGridContainer>
  );
};

export default LegacyEnterpriseReturnToProgramBanner;
